import type {LoaderFunctionArgs} from 'react-router'
import {useLoaderData} from 'react-router-dom'
import {getNavigationState} from '../../helpers/navigationStateCache.ts'
import {getInitialProps} from './getInitialProps'
import NetComponent from './index'

import './styles/index.scss'

export async function loader({context, request, params}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const pathname = url.pathname

  const routeInfo = {
    location: {
      pathname,
      query: Object.fromEntries(url.searchParams.entries()),
      search: url.search,
      state: getNavigationState(pathname)
    },
    params
  }

  return getInitialProps({routeInfo, context})
}

export function Component() {
  const data = useLoaderData()
  return <NetComponent {...data} />
}
